module.exports = __webpack_public_path__ + "static/img/logo3.a1e3ea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo3.png
// module id = kHxW
// module chunks = 1